export default __webpack_public_path__ + "static/media/SJA0450.34I-36953_-25735_0.73362932.jpg";